module.exports = __webpack_public_path__ + "img/small-pump-right.fa519e5a.png";